import React from 'react';

import { LiveIcon } from '@/assets/icons/live-indicator';
import MergedLogos from '@/components/MergedLogos';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';

import { ds } from '../lib/design.system';
import { TeamLogos } from '../scoreboard/types';

type MatchupHeaderProps = {
    logos: TeamLogos;
    shouldShowFallbackLogos: [boolean, boolean];
    teamFallbackTextColors: string[];
    teamShortCodes: string[];
    isHeaderDisabled: boolean;
    eventHeader: string;
    isLive?: boolean;
};

export const MatchupHeader = ({ isHeaderDisabled, eventHeader, ...matchUpHeaderProps }: MatchupHeaderProps) => {
    return (
        <Row alignItems="center">
            <Box width={44} height={24} overflow="hidden" marginRight={'s12'}>
                <Box position="absolute" top={-2} left={-2}>
                    <MergedLogos
                        borderColor={ds.colorValue.background.neutral.base} // acts as a spacer between logos, not as border
                        renderMode="shield"
                        overlap={6}
                        logoSizes={[16, 16]}
                        backdropSizes={[28, 24]}
                        imageShape="square"
                        borderRadius={8}
                        {...matchUpHeaderProps}
                    />
                </Box>
            </Box>
            <Text
                variant="bodySmall"
                paddingVertical={'s2'}
                color={isHeaderDisabled ? 'neutral400' : ds.colorToken.text.secondary}
                testID="comboCardEventDetails"
                marginRight={'s8'}
            >
                {eventHeader}
            </Text>
            {matchUpHeaderProps.isLive ? <LiveIcon /> : null}
        </Row>
    );
};
